
import { Filter } from "@/cms-services/filter";
import { FunnelStageLeadDataSource, ListDataSource } from "@/data/List/ListDataSource";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import  ParamStringEditor from "../param-editors/string.vue";
import ParamTextEditor from "../param-editors/text.vue";
import ParamBoolEditor from "../param-editors/bool.vue";
import ParamNumberEditor from "../param-editors/number.vue";
import ParamDateTimeEditor from "../param-editors/date-time.vue";
import ParamEnumEditor from "../param-editors/enum.vue";
import _ from "lodash";
import moment from "moment";
import {Vue,Component, Prop, Ref, Watch} from "vue-property-decorator"
import draggable from "vuedraggable";
import { mdiArrowAll, mdiCog, mdiDownload, mdiOpenInNew, mdiPen, mdiPlus, mdiStar, mdiTrashCan, mdiUpload } from "@mdi/js";
import FilePreviews from "@/mixins/file-types/index";
import { getFilePreview } from "@/cms-services/helpers";



@Component({
      mixins: [FilePreviews],

    components:{
        draggable,
        ParamStringEditor,
        ParamTextEditor,
        ParamBoolEditor,
        ParamNumberEditor,
        ParamDateTimeEditor,
        ParamEnumEditor
    }
})
export default class FunnelStageLeads extends Vue {
    @Ref("form") form!:any
    @Prop() funnelStage:any
    @Prop() clientDataSource!:ListDataSource
    @Prop() leadClassDataSource!:ListDataSource
    

    selectedFolder:any = null;
    clientLoading = false;
    editMode = false
    searchText = "";
    $message:any
    timeout:any
    dialog = false;
    updateDialog = false;
    clientDialog = false
    tab = 0

    icons: any = {
        plus: mdiPlus,
        download:mdiDownload,
        arrowAll: mdiArrowAll,
        cog: mdiCog,
        delete: mdiTrashCan,
        pen: mdiPen,
        upload: mdiUpload,
        star: mdiStar,
        open: mdiOpenInNew,
    };

    getFilePreview = getFilePreview;


    stageDataSource:ObjectDataSource = new ObjectDataSource({
        className:"LeadFunnelStage",
        id:0,
        config:{}
    })

    dataSource:FunnelStageLeadDataSource = new FunnelStageLeadDataSource({
        className:"FunnelStageLead",
        config:{}
    })

    leadDataSource:ObjectDataSource = new ObjectDataSource({
        className:"Lead",
        id:0,
        config:{}
    })

    folderDataSource:ListDataSource = new ListDataSource({
        className:"LeadFileFolder",
        config:{
            pageIndex:1,
            pageSize:1000
        }
    })

    fileDataSource:ListDataSource = new ListDataSource({
        className:"LeadFile",
        config:{
            pageIndex:1,
            pageSize:1000
        }
    })

    model = {
        sum:0,
        caption:"",
        description:"",
        clientId:null,
        leadClassId:null,
        params:[]
    }

    clientModel = {
        firstName:"",
        lastName:"",
        patronymic:"",
        phoneNumber:"",
        email:"",
    }

    clientFields = [
        {
            name:"lastName",
            editor:"string",
            attrs:{
                label:"Фамилия",
            },
            grid:{cols:4}
        },
        {
            name:"firstName",
            editor:"string",
            grid:{cols:4},

            attrs:{
                label:"Имя",
            },
        },
        {
            name:"patronymic",
            editor:"string",
            grid:{cols:4},
            attrs:{
                label:"Отчество",
                hint:"",
                rows:5
            }
        },
        {
            name:"phoneNumber",
            editor:"string",
            grid:{cols:6},
            attrs:{
                mask:"+7 (###) ###-##-##",
                label:"Номер телефона",
            },
        },
        {
            name:"email",
            editor:"string",
            grid:{cols:6},
            attrs:{
                label:"Почта",
            },
        }
    ]

    fields = [
        {
            name:"caption",
            editor:"string",
            attrs:{
                label:"Заголовок",
            },
            grid:{cols:6}
        },
        {
            name:"sum",
            editor:"number",
            attrs:{
                label:"Сумма",
            },
            grid:{cols:6}
        },
        {
            name:"description",
            editor:"string",
            attrs:{
                label:"Описание",
                hint:"",
                rows:5
            }
        }
    ]

    actions = {
        getClients: async () => this.clientDataSource.items
    }

    colors = [
        ["#AAF0D1", "#B0E57C", "#D8BFD8", "#ADD8E6"],
        ["#90EE90", "#FFB6C1", "#FFA07A", "#F5DEB3"],
        ["#E6E6FA", "#F0E68C", "#B0C4DE", "#87CEFA"],
        ["#FF69B4", "#FFDAB9", "#EEE8AA", "#98FB98"],
        ["#AFEEEE", "#DB7093", "#F08080", "#FAFAD2"]
    ];
    $confirm: any;

    get files(){
        if(this.selectedFolder?.id) return this.fileDataSource.items.filter(i => i.leadFileFolderId == this.selectedFolder?.id) 
        return  this.fileDataSource.items.filter(i => !i.leadFileFolderId);
    }

    get leadClass(){
        return this.leadClassDataSource.items.find(i => i.id == this.model.leadClassId);
    }

    get totalSum(){
        const sum = this.dataSource.items.reduce((acc, n) => acc+=n.lead.sum,0);
        return this.formatCurrency(sum);
    }

    getFolderDataSource(){
        return new ObjectDataSource({
            className:"LeadFileFolder",
            model:this.selectedFolder,
            id:this.selectedFolder.id,
            config:{}
        })
    }

    isImage(fileName: string): boolean {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
        const extension = fileName.split('.').pop()?.toLowerCase();
        return imageExtensions.includes(extension || '');
    }

    toKebabCase = (str: string): string => str
        .replace(/([a-z])([A-Z])/g, '$1-$2') 
        .replace(/\s+/g, '-')             
        .toLowerCase();     

    getInlineEditor(param:any){
        const leadClass = this.leadClassDataSource.items.find(i => i.id == param.leadClassId);
        if(!leadClass) return null;
        const leadClassParam = leadClass.params.find(i => i.id == param.leadClassParamId);
        return leadClassParam?.editor ?  "inline-editor-"+this.toKebabCase(leadClassParam?.editor) : null;
    }

    getParamItems(param:any){
        const leadClass = this.leadClassDataSource.items.find(i => i.id == param.leadClassId);
        if(!leadClass) return null;
        const leadClassParam = leadClass.params.find(i => i.id == param.leadClassParamId);
        if(!leadClassParam) return null;
        return leadClassParam?.items 
            ? leadClassParam?.items.map((i:any) => ({
                id:i.value,
                caption:i.caption
            }))
            : [];
    }


    getDataSource(param:any){
        return new ObjectDataSource({
            className:"LeadParam",
            id:param.id,
            model:param,
            config:{}
        })
    }

    formatCurrency(item){
        const num = Number(parseFloat(item).toFixed(0));
        return num.toLocaleString('ru-RU') ;
    }

    getEditor(leadClassParam:any){
        return leadClassParam?.editor ? `param-${leadClassParam?.editor}-editor` : null;
    }

    formatDate(item){
        return moment(item.lead.createDate).format("DD.MM.YYYY")
    }

    updateLeadParams(leadClassId:any){
        const leadClass = this.leadClassDataSource.items.find(i => i.id == leadClassId);
        if(!leadClass) return;
        this.model.params = leadClass.params
            .sort((p:any, n:any) => p.priority - n.priority)
            .map((i:any) => ({
                caption:i.caption,
                leadClassId: leadClassId,
                priority: i.priority,
                leadClassParamId: i.id,
                value: "",
            }))
    }

    clear(){
        this.dialog = false;
        this.model.caption = "";
        this.model.sum = 0;
        this.model.description = ""
        this.model.clientId = null
    }

    async addImage({ file }: any) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async ({ target }: any) => {
            try {
                await this.fileDataSource.add({
                    name: file.name,
                    size: file.size,
                    leadId: this.leadDataSource.model.id,
                    base64: target.result?.toString().split(",")[1],
                    leadFileFolderId: this.selectedFolder?.id
                });
                this.$message("Изображение успешно добавлено");
            } catch (error) {
                this.$message(error, "error");
            }
        };
    }


    async addFolder(){
        await this.folderDataSource.add({
            caption:"Новая папка",
            leadId:this.leadDataSource.id
        })
    }

    async removeFolder(folder:any){
        const confirm: any = await this.$confirm(
            "Вы действительно хотите удалить данную папку?"
        );
        if (!confirm) return;    
        await this.folderDataSource.remove(folder.id)
    }

    @Watch("searchText")
    async searchClient(e){
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
            this.clientLoading = true;
            this.clientDataSource.config.filter = JSON.stringify([
                new Filter("searchText", e)
            ])
            await this.clientDataSource.get();
            this.clientLoading = false;
        }, 100);
    }

    async selectClient(item:any) {
        this.leadDataSource.model.client = item;
        await this.leadDataSource.updateField({
            fieldName:"clientId",
            fieldValue:item.id
        })
        this.editMode = false;
        this.$message("Клиент успешно выбран")
    }

    async updateColor(event:any){
        if(event.hex == "#FF0000") return;
        
        await this.stageDataSource.updateField({
            fieldName:"color",
            fieldValue: event.hex
        })
    }

    async dragItem({added}:any){
        
        if(added?.element){
            console.log("updateStage");
            
            await this.dataSource.updateStage(added.element.id, this.funnelStage.id)
        }

        await this.dataSource.changePriority();
    }


    async add(){
        const valid = await this.form.validate();
        if(!valid){
            this.$message("Пожалуйста заполните форму корректно","error");
            return;
        }
        await this.dataSource.addLead(this.model,  this.funnelStage.leadFunnelId, this.funnelStage.id);
        
        this.clear();
    }

    clearClient(){
        this.clientDialog = false;
        this.clientModel.firstName="";
        this.clientModel.lastName="";
        this.clientModel.patronymic="";
        this.clientModel.phoneNumber="";
        this.clientModel.email="";
    }


    async addClient(){
        const result = await this.clientDataSource.add({...this.clientModel})
        this.model.clientId = result.id;
        this.searchText = result.fullName;
        this.clearClient();
    }

    async remove(item:any){
        await this.dataSource.remove(item.id);
    }

    async update(lead:any){
        this.leadDataSource.id=lead.id;
        this.leadDataSource.model = lead;
        this.folderDataSource.items = lead.fileFolders;
        this.fileDataSource.items = lead.files;
        this.updateDialog = true;
    }

    created(){
        this.stageDataSource.id = this.funnelStage.id;
        this.stageDataSource.model = this.funnelStage;
        this.dataSource.items = this.funnelStage.funnelStageLeads.sort((p: any, n: any) => p.priority - n.priority);
        this.model.leadClassId = this.leadClassDataSource.items.find(i => i.isDefault).id;

        this.updateLeadParams(this.model.leadClassId);  
    }
}
